export const LanguageConstants = {
    "datasource": "Data Source",
    "datasource_s": "Data Sources",
    "group": "Workspace",
    "group_s": "Workspaces",
    "topic": "Channel",
    "topic_s": "Channels",
    "thread": "Thread",
    "thread_s": "Threads",
}
